import React, {Component} from "react";
import ExtAppService from "../../api/services/ExtAppService";

import './PendingBadge.css';

export default class PendingBadge extends Component{
	constructor(props) {
		super(props);
		this.state = { pending: ExtAppService.Pending }
	}
	componentDidMount() {
		ExtAppService.AddListener('pending-badge', this.updateBadge);
		ExtAppService.UpdatePending();
	}

	componentWillUnmount() {
		ExtAppService.RemoveListener('pending-badge');
	}

	updateBadge = (pending) => {
		this.setState({pending: pending});
	}

	render() {
		return (
			<div className={`pending-badge ${this.state.pending.length? '':'hidden'}`}>{this.state.pending.length}</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/pending/PendingBadge.jsx